module.exports = __webpack_public_path__ + "static/media/team-introduction-3.8ce6e041.jpg";